/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Loader } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import cloneDeep from 'lodash/cloneDeep';
import cx from 'classnames';
import Chart from 'chart.js/auto';
import api from '../../api';

class IssueSummary extends Component {
  constructor(props) {
    super(props);
    this.doughnutChart_1 = null;
    this.doughnutChart_2 = null;
    this.doughnutChart_3 = null;
    this.state = {
      isLoading: false,
      projectCount: '',
      issueCount: {
        total: 0,
        undecided: 0,
        resolved: 0,
        disregarded: 0,
      },
      securityCount: {
        total: 0,
        undecided: 0,
        resolved: 0,
        disregarded: 0,
      },
      licenseCount: {
        total: 0,
        undecided: 0,
        resolved: 0,
        disregarded: 0,
      },
      litigatorCount: {
        total: 0,
        undecided: 0,
        resolved: 0,
        disregarded: 0,
      },
      //reportCount: '',
      isPageLoading: false,
    };
  }

  componentDidMount() {
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getMyIssueSummary();
      this.setState({
        isPageLoading: false,
      });
    }

    if (prevState.securityCount.total !== this.state.securityCount.total && !this.state.isLoading) {
      this.drawDoughnutChartSecurity();
    }
    if (prevState.licenseCount.total !== this.state.licenseCount.total && !this.state.isLoading) {
      this.drawDoughnutChartLicense();
    }
    if (prevState.litigatorCount.total !== this.state.litigatorCount.total && !this.state.isLoading) {
      this.drawDoughnutChartLitigator();
    }
  }

  componentWillUnmount() {
    if (this.doughnutChart_1) {
      this.doughnutChart_1.destroy();
    }
    if (this.doughnutChart_2) {
      this.doughnutChart_2.destroy();
    }
    if (this.doughnutChart_3) {
      this.doughnutChart_3.destroy();
    }
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  getMyIssueSummary() {
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getMyIssueSummary()
        .then((response) => {
          const data = response.response;
          this.setState({
            isLoading: false,
            projectCount: data.assigned_project_count,
            issueCount: data.assigned_issue_count,
            securityCount: data.security_count,
            licenseCount: data.license_count,
            litigatorCount: data.litigator_count,
            //reportCount: data.report_count,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  abbreviateNumber(value) {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      //if (shortValue % 1 !== 0) {
      //const shortNum = shortValue.toFixed(1);
      //console.log(shortNum);
      //}
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  drawDoughnutChartSecurity() {
    if (this.doughnutChart_1) {
      this.doughnutChart_1.destroy();
      this.doughnutChart_1 = null;
    }
    const { undecided, resolved, disregarded } = this.state.securityCount;
    const config = {
      type: 'doughnut',
      data: {
        datasets: [
          {
            label: ['undecided', 'resolved', 'disregarded'],
            data: [undecided, resolved, disregarded],
            backgroundColor: ['#21beff', '#61e286', '#D0D0D0'],
            borderWidth: 0,
          },
        ],
      },
      options: {
        //maintainAspectRatio: false,
        //responsive: true,
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
          },
        }
      },
    };

    const ctx = this.securityChart.getContext('2d');
    this.doughnutChart_1 = new Chart(ctx, config);
  }

  drawDoughnutChartLicense() {
    if (this.doughnutChart_2) {
      this.doughnutChart_2.destroy();
      this.doughnutChart_2 = null;
    }
    const { undecided, resolved, disregarded } = this.state.licenseCount;
    const config = {
      type: 'doughnut',
      data: {
        datasets: [
          {
            //label: ['undecided', 'resolved', 'disregarded'],
            data: [undecided, resolved, disregarded],
            backgroundColor: ['#21beff', '#61e286', '#D0D0D0'],
            borderWidth: 0,
          },
        ],
      },
      options: {
        //maintainAspectRatio: false,
        //responsive: true,
        plugins: {
          tooltips: {
            enabled: false,
          },
          legend: {
            display: false,
          },
        }
      },
    };

    const ctx = this.licenseChart.getContext('2d');
    this.doughnutChart_2 = new Chart(ctx, config);
  }

  drawDoughnutChartLitigator() {
    const { t } = this.props;
    if (this.doughnutChart_3) {
      this.doughnutChart_3.destroy();
      this.doughnutChart_3 = null;
    }
    const { undecided, resolved, disregarded } = this.state.litigatorCount;
    const config = {
      type: 'doughnut',
      data: {
        datasets: [
          {
            label: [t('chart.title.undecided'), t('chart.title.resolved'), t('chart.title.disregarded')],
            data: [undecided, resolved, disregarded],
            backgroundColor: ['#21beff', '#61e286', '#D0D0D0'],
            borderWidth: 0,
          },
        ],
      },
      options: {
        //maintainAspectRatio: false,
        //responsive: true,
        plugins: {
          tooltips: {
            enabled: false,
          },
          legend: {
            display: false,
          },
        }
      },
    };

    const ctx = this.litigatorChart.getContext('2d');
    this.doughnutChart_3 = new Chart(ctx, config);
  }

  renderBarChart = (count) => {
    const { t } = this.props;
    const currentLocale = localStorage.getItem('i18nextLng');
    const dummyData = cloneDeep(count);
    delete dummyData.total;

    if (count.undecided === 0 && count.resolved === 0 && count.disregarded === 0) {
      return (
        <div className="vertical_bar_chart">
          <div className="blue">
            <div className="bar" style={{ height: '0' }} />
            <div className="value">{count.undecided}</div>
            <div
              className={cx(
                'label',
                {
                  kr: currentLocale === 'kr',
                },
                {
                  ja: currentLocale === 'ja',
                },
                {
                  en: currentLocale === 'en',
                },
              )}
            >
              {t('chart.title.undecided')}
            </div>
          </div>
          <div className="green">
            <div className="bar" style={{ height: '0' }} />
            <div className="value">{count.resolved}</div>
            <div
              className={cx(
                'label',
                {
                  kr: currentLocale === 'kr',
                },
                {
                  ja: currentLocale === 'ja',
                },
                {
                  en: currentLocale === 'en',
                },
              )}
            >
              {t('chart.title.resolved')}
            </div>
          </div>
          <div className="gray">
            <div className="bar" style={{ height: '0%' }} />
            <div className="value">{count.disregarded}</div>
            <div
              className={cx(
                'label',
                {
                  kr: currentLocale === 'kr',
                },
                {
                  ja: currentLocale === 'ja',
                },
                {
                  en: currentLocale === 'en',
                },
              )}
            >
              {t('chart.title.disregarded')}
            </div>
          </div>
        </div>
      );
    }

    const maxKey = Object.keys(dummyData).reduce((a, b) => {
      return dummyData[a] > dummyData[b] ? a : b;
    });

    const undecidedValue = `${Math.round((count.undecided / count[maxKey]) * 100)}%`;
    const resolveddValue = `${Math.round((count.resolved / count[maxKey]) * 100)}%`;
    const disregardedValue = `${Math.round((count.disregarded / count[maxKey]) * 100)}%`;

    return (
      <div className="vertical_bar_chart my_summary">
        <div className="blue">
          <div className="bar" style={{ height: undecidedValue || 0 }} />
          <div className="value" style={{ bottom: undecidedValue || 0 }}>{this.abbreviateNumber(count.undecided)}</div>
          <div
            className={cx(
              'label',
              {
                kr: currentLocale === 'kr',
              },
              {
                ja: currentLocale === 'ja',
              },
              {
                en: currentLocale === 'en',
              },
            )}
          >
            {t('chart.title.undecided')}
          </div>
        </div>
        <div className="green">
          <div className="bar" style={{ height: resolveddValue || 0 }} />
          <div className="value" style={{ bottom: resolveddValue || 0 }}>{this.abbreviateNumber(count.resolved)}</div>
          <div
            className={cx(
              'label',
              {
                kr: currentLocale === 'kr',
              },
              {
                ja: currentLocale === 'ja',
              },
              {
                en: currentLocale === 'en',
              },
            )}
          >
            {t('chart.title.resolved')}
          </div>
        </div>
        <div className="gray">
          <div className="bar" style={{ height: disregardedValue || 0 }} />
          <div className="value" style={{ bottom: disregardedValue || 0 }}>{this.abbreviateNumber(count.disregarded)}</div>
          <div
            className={cx(
              'label',
              {
                kr: currentLocale === 'kr',
              },
              {
                ja: currentLocale === 'ja',
              },
              {
                en: currentLocale === 'en',
              },
            )}
          >
            {t('chart.title.disregarded')}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      isLoading,
      projectCount,
      issueCount,
      securityCount,
      licenseCount,
      litigatorCount,
    } = this.state;

    const { t } = this.props;

    return (
      <div className="my_issues_summary">
        <div className="my_issues_summary_inner">
          {
            isLoading ? (
              <div style={{ paddingBottom: '14px' }}>
                <Loader active={isLoading} inline="centered" />
              </div>
            ) : (
              <table className="my_issues_summary_table">
                <colgroup>
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '13%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '57%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td className="first">
                      <div className="inner_box">
                        <span className="number">{projectCount}</span>
                        <span className="unit">{t('panel.on_going_project')}</span>
                        <p className="label">{t('panel.assigned_project')}</p>
                      </div>
                    </td>
                    <td>
                      <div className="inner_box">
                        <span className="number">{issueCount.total}</span>
                        <p className="label">{t('panel.assigned_issues')}</p>
                      </div>
                    </td>
                    <td>
                      {this.renderBarChart(issueCount)}
                    </td>
                    <td>
                      &nbsp;
                    </td>
                    <td>
                      <div className="inner_box doughnut_chart_wrap">
                        <div className="chart_info">
                          <p className="number">
                            <em>{securityCount.undecided}</em>
                            /
                            {securityCount.total}
                          </p>
                          <p className="label">{t('project.menu.security')}</p>
                        </div>
                        {
                          securityCount.total === 0 ? (
                            <div className="chart" />
                          ) : (
                            <div className="chart">
                              <canvas
                                ref={(ref) => {
                                  this.securityChart = ref;
                                }}
                                className="doughnut_chart_1"
                              />
                            </div>
                          )
                        }
                      </div>
                      <div className="inner_box doughnut_chart_wrap">
                        <div className="chart_info">
                          <p className="number">
                            <em>{licenseCount.undecided}</em>
                            /
                            {licenseCount.total}
                          </p>
                          <p className="label">{t('project.menu.licenses')}</p>
                        </div>
                        {
                          licenseCount.total === 0 ? (
                            <div className="chart" />
                          ) : (
                            <div className="chart">
                              <canvas
                                className="doughnut_chart_2"
                                ref={(ref) => {
                                  this.licenseChart = ref;
                                }}
                              />
                            </div>
                          )
                        }
                      </div>
                      <div className="inner_box doughnut_chart_wrap">
                        <div className="chart_info">
                          <p className="number">
                            <em>{litigatorCount.undecided}</em>
                            /
                            {litigatorCount.total}
                          </p>
                          <p className="label">{t('project.menu.litigator')}</p>
                        </div>
                        {
                          litigatorCount.total === 0 ? (
                            <div className="chart" />
                          ) : (
                            <div className="chart">
                              <canvas
                                className="doughnut_chart_3"
                                ref={(ref) => {
                                  this.litigatorChart = ref;
                                }}
                              />
                            </div>
                          )
                        }
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            )
          }
        </div>
      </div>
    );
  }
}

export default withTranslation()(IssueSummary);
